import React from 'react'
import Doughnut from '../../../components/charts/doughnut/doughnut'
import BarChart from '../../../components/charts/barchart/barchart'
import LineChart from '../../../components/charts/linechart/linechart'
import RadarChart from '../../../components/charts/radarchart/radarchart'

const Graficas = () => {

  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Gráficas</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              <BarChart />
            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              <LineChart />
            </div>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              <Doughnut />
            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              <RadarChart />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Graficas